<template>
    <div>
        <div class="page">
            <div class="container">
                <div class="row justify-content-center" style="margin-top:65px;">
                    <div class="col-md-8">
                        <div class="row align-items-center">
                            <div class="col text-center">
                                <center><img id="logo" src="../assets/ldr-logo-with-title.png" class="img-fluid"></center>
                            </div>
                            <div class="col text-center" v-if="showSvi">
                                <img src="../assets/whitelabels/svi_white.jpg" class="img-fluid" style="height:130px;"/>
                            </div>
                            <div class="col text-center" v-if="showIdh">
                                <img src="../assets/whitelabels/idh.png" class="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">                    
                    <div class="col-md-7">
                        
                        <div style="padding:20px;margin:40px 20px;background-color:#f6f6f6;border:1px solid #ccc;">
                            <h2 style="margin:10px 0px 20px 0px;">Log in with your account:</h2>
                            <form>
                              <div class="form-group">
                                <label for="email"  v-bind:class="{ 'is-invalid':error }">Username or e-mail address</label>
                                <input ref="username" type="email" class="form-control"  v-bind:class="{ 'is-invalid':error }" id="email" aria-describedby="emailHelp" placeholder="">
                              </div>
                              <div class="form-group">
                                <label for="password"  v-bind:class="{ 'is-invalid':error }">Password</label>
                                <input ref="password" type="password" class="form-control" v-bind:class="{ 'is-invalid':error }" id="password" placeholder="">
                              </div>

                                <div v-if="error" class="is-invalid" style="padding-bottom:17px;">
                                    Authentication failed. Please check your credentials or get in touch via info@geofolio.org if you feel that an error has occurred.
                                </div>


                              <div class="row">
                                <div class="col text-left">
                                    <button type="submit" ref="login" @click.prevent="login" class="btn btn-lg btn-primary" :disabled="disabled"><strong>Login</strong></button>
                                </div>
                               </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Footer / -->
    </div>
</template>

<script>
  import Footer from '@/components/generic/Footer.vue'

  export default {
    name: 'login',
    components: {
      Footer
    },
    data() {
        return {
            error: false,
            disabled: false
        }
    },
      mounted() {
        //this.$refs["username"].focus()
      },
    computed: {
        count() {
            return this.$store.state.count
        },
        isValid() {
            if(this.error) {
                return "is-invalid"
            } else {
                return ""
            }
        },
        showSvi() {
            var wl = this.$route.query.wl ? this.$route.query.wl : ""
            return wl.includes("svi");
        },
        showIdh() {
            var wl = this.$route.query.wl ? this.$route.query.wl : ""
            return wl.includes("idh");
        },
    },
    methods: {
      login() {
        this.$refs["login"].blur()
        this.disabled = true;
        const params = {
           'username': this.$refs.username.value,
           'password': this.$refs.password.value
        }
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/login", params, { headers: headers })
           .then(response => {
                this.error = false;
                this.$store.commit('profile', response.data.profile)
                this.$store.commit('profile_pub', response.data.profile_pub)
                this.disabled = false;
                this.$router.push({name: 'home'})    

           })
           .catch(error => {
                this.error = true;
                this.disabled = false;
           })
      }
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.1em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}
.is-invalid {
    color: #dc3545;
}
label.is-invalid {
    font-weight:bold;
}
</style>